import axios from "./api";

// 首页数据
export const homeinfo = () => {
  return axios({
    url: "/cms/mobileinfo",
    baseURL:
      process.env.NODE_ENV === "development"
        ? "http://connect.jzyx.com"
        : process.env.NODE_ENV === "test"
        ? "http://connect-test.jzyx.com"
        : "https://connect.jzyx.com",
    loading: true
  });
};

// 上传
export function upload(data) {
  return axios({
    url: "/v2/common/upload",
    method: "post",
    data,
    loading: true,
    common: true,
    qs: false
  });
}
